module.exports = __webpack_public_path__ + "img/dv.e96351fd.svg";